(function () {
  "use strict";

  class ConvxCollections extends HTMLElement {
    constructor() {
      super();
      this.collectionBlocks = this.querySelector(".convx__collection-blocks");
      this.subTabsContainer = this.querySelector(".convx__sub-tabs");
      this.productList = this.querySelector(".convx__product-list");
      this.productCountElement = this.querySelector(".product-count");
      this.flickityInstance = null;
      this.progressBar = null;
      this.sortDropdown = this.querySelector("#SortBy");
      this.currentSectionId = "convx__product-list";
      this.initialize();
      this.windowWidth = window.innerWidth;
    }

    isMobile() {
      return window.matchMedia("(max-width: 768px)").matches;
    }

    /*connectedCallback() {
      this.initFlickity();
      window.addEventListener("resize", this.updateFlickity.bind(this));
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.updateFlickity.bind(this));
      if (this.flickityInstance) {
        this.flickityInstance.destroy();
      }
    }

    getFlickityOptions() {
      return window.innerWidth < 768
        ? {
            cellAlign: "center",
            contain: true,
            groupCells: true,
            draggable: true,
            prevNextButtons: true,
            pageDots: false,
            freeScroll: true,
            adaptiveHeight: true,
            percentPosition: true,
            imagesLoaded: true,
          }
        : {
            cellAlign: "center",
            contain: true,
            groupCells: false,
            draggable: true,
            prevNextButtons: false,
            pageDots: false,
            freeScroll: true,
            adaptiveHeight: false,
            percentPosition: true,
            imagesLoaded: true,
          };
    }

    initFlickity() {
      if (this.flickityInstance) {
        this.flickityInstance.destroy();
      }

      this.flickityInstance = new Flickity(
        this.collectionBlocks,
        this.getFlickityOptions()
      );

      this.progressBar = this.querySelector(".progress-bar");
      if (this.progressBar) {
        this.flickityInstance.on("scroll", (progress) => {
          progress = Math.max(0, Math.min(1, progress));
          this.progressBar.style.width = progress * 100 + "%";
        });
      }
    }

    updateFlickity() {
      if (window.innerWidth !== this.windowWidth) {
        this.windowWidth = window.innerWidth;
        this.initFlickity();
      }
    }*/

    initialize() {
      const urlParams = new URLSearchParams(window.location.search);
      const pathMatch = window.location.pathname.match(
        /\/collections\/([^\/]+)(?:\/([^\/\?]+))?/
      );
      const collectionHandle = pathMatch?.[1] || "all";
      const initialTag = pathMatch?.[2] || "all";

      const currentSortBy = urlParams.get("sort_by") || "manual";

      const categoryBtns = this.collectionBlocks.querySelectorAll(
        "[data-collection-handle]"
      );
      if (!categoryBtns.length) return;

      // Function to handle the collection rendering based on the URL handle
      const setActiveCollection = (handle, tag = "all") => {
        const collectionBtn = Array.from(categoryBtns).find(
          (btn) => btn.dataset.collectionHandle === handle
        );
        const campaignBtn = Array.from(categoryBtns).find(
          (btn) => btn.dataset.collectionHandle === 'scary-good-sale'
        );

        categoryBtns.forEach((btn) =>
          btn.classList.remove("convx__collection-selected-btn")
        );
        if (collectionBtn) {
          collectionBtn.classList.add("convx__collection-selected-btn");
        } else {
          if (campaignBtn) {
            campaignBtn.classList.add("convx__collection-selected-btn");
          }
        }
        this.renderCollection(handle, tag, currentSortBy);
      };

      // Handle the initial load or popstate (back/forward button)
      setActiveCollection(collectionHandle, initialTag);

      // Listen for changes in the browser history (back/forward buttons)
      window.addEventListener("popstate", () => {
        const match = window.location.pathname.match(
          /\/collections\/([^\/]+)(?:\/([^\/\?]+))?/
        );
        const handle = match?.[1] || "all";
        const tag = match?.[2] || "all";
        setActiveCollection(handle, tag);
      });

      // Handle clicks on collection buttons
      categoryBtns.forEach((btn) => {
        const handle = btn.dataset.collectionHandle;
        btn.addEventListener("click", () => {
          if (btn.classList.contains("convx__collection-selected-btn")) return;

          categoryBtns.forEach((b) =>
            b.classList.remove("convx__collection-selected-btn")
          );
          btn.classList.add("convx__collection-selected-btn");

          history.pushState({}, "", `/collections/${handle}`);

          const sizingGuideText = document.querySelector(".sizing-guide-text");
          if (sizingGuideText) {
            sizingGuideText.style.display = "none";
            console.log("hide sizing guide");
          }
          const sizingGuideTextRed = document.querySelector(
            ".sizing-guide-text-red"
          );
          if (sizingGuideTextRed) {
            sizingGuideTextRed.style.display = "none";
            console.log("hide sizing guide");
          }

          // Render the collection
          this.renderCollection(handle);
        });
      });

      // Attach sorting functionality to Shopify's built-in sorting mechanism
      if (this.sortDropdown) {
        this.sortDropdown.value = currentSortBy;
        this.sortDropdown.addEventListener("change", () => {
          const sortBy = this.sortDropdown.value;
          this.updateCollectionSort(sortBy);
        });
      }
    }

    updateCollectionSort(sortBy) {
      const currentUrl = new URL(window.location);
      currentUrl.searchParams.set("sort_by", sortBy);
      history.pushState({}, "", currentUrl.toString());

      const pathMatch = window.location.pathname.match(
        /\/collections\/([^\/]+)(?:\/([^\/\?]+))?/
      );
      const collectionHandle = pathMatch?.[1] || "all";
      const activeTag = pathMatch?.[2] || "all";

      this.renderCollection(collectionHandle, activeTag, sortBy);
    }

    updateProductCount() {
      const totalCount = this.productList.querySelectorAll(
        "[data-product-tags]"
      ).length;
      const countElement = this.querySelector(".product-count");
      const oriTotal = this.querySelector("[data-total-count]");
      const headerCountElement = this.querySelector(".product-count-header");
      const collectionProgressBar = this.querySelector(
        ".collection-progress-bar"
      );
      const originalTotal2 = parseInt(oriTotal.dataset.totalCount, 10);

      if (countElement) {
        const originalTotal = parseInt(countElement.dataset.totalCount, 10);

        countElement.textContent = `${totalCount} of ${originalTotal} Product${originalTotal !== 1 ? "s" : ""
          }`;

        // Update progress bar
        if (collectionProgressBar && originalTotal > 0) {
          const progress = (totalCount / originalTotal) * 100;
          collectionProgressBar.style.width = `${progress}%`;
        }
      }
      if (headerCountElement) {
        headerCountElement.textContent = `${originalTotal2} Product${originalTotal2 !== 1 ? "s" : ""
          }`;
      }
      bindSpinnerClickEvents(500);
    }

    renderLoadMore() {
      const loadMoreBtn = this.querySelector(".load-more-btn");

      if (!loadMoreBtn) return;

      loadMoreBtn.addEventListener("click", () => {
        const nextUrl = loadMoreBtn.dataset.nextUrl;

        if (!nextUrl) return;

        loadMoreBtn.textContent = "Loading...";
        bindSpinnerClickEvents(500);

        fetch(nextUrl + "&section_id=" + this.currentSectionId)
          .then((res) => res.text())
          .then((html) => {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = html;

            const newProducts = tempDiv.querySelectorAll(
              ".convx__products-grid > *"
            );
            const nextButton = tempDiv.querySelector(".load-more-btn");

            newProducts.forEach((product) => {
              this.productList
                .querySelector(".convx__products-grid")
                .append(product);
            });

            if (nextButton) {
              loadMoreBtn.dataset.nextUrl = nextButton.dataset.nextUrl;
              loadMoreBtn.textContent = "Load More";
            } else {
              loadMoreBtn.remove(); // No more pages
            }

            this.updateProductCount();
          })
          .catch((error) => {
            console.error("Load more failed:", error);
            loadMoreBtn.textContent = "Load Failed. Try again.";
          });
      });
    }

    renderCollection(collectionHandle, activeTag = "all", sortBy = "manual") {
      this.showLoading();

      const tagPath = activeTag && activeTag !== "all" ? `/${activeTag}` : "";
      this.currentSectionId = this.isMobile()
        ? "convx__product-list-mobile"
        : "convx__product-list";
      const subTabsPromise = fetch(
        `/collections/${collectionHandle}?section_id=convx__sub-tabs`
      ).then((res) => res.text());
      const productListPromise = fetch(
        `/collections/${collectionHandle}${tagPath}?section_id=${this.currentSectionId}&sort_by=${sortBy}`
      ).then((res) => res.text());

      Promise.all([subTabsPromise, productListPromise])
        .then(([subTabsHtml, productsHtml]) => {
          const tempSubTabs = document.createElement("div");
          tempSubTabs.innerHTML = subTabsHtml;

          this.subTabsContainer.innerHTML = "";
          if (tempSubTabs.children.length > 0) {
            this.subTabsContainer.append(tempSubTabs.children[0]);
          }

          const tempProducts = document.createElement("div");
          tempProducts.innerHTML = productsHtml;
          this.productList.innerHTML = "";

          if (
            tempProducts.children.length > 0 &&
            tempProducts.children[0].children.length > 0
          ) {
            Array.from(tempProducts.children[0].children).forEach((child) => {
              this.productList.append(child);
            });

            this.updateProductCount();
          }

          const subTabButtons =
            this.subTabsContainer.querySelectorAll(".convx__sub-tab");
          subTabButtons.forEach((tabBtn) => {
            const tabTag = tabBtn.dataset.subTag;
            tabBtn.classList.toggle(
              "active",
              tabTag.toLowerCase().replace(/\s+/g, "-") ===
              activeTag.toLowerCase().replace(/\s+/g, "-")
            );
            console.log("tabTag", tabTag);
            console.log("activeTag", activeTag);
          });

          this.attachSubTabsEvents(activeTag);

          this.hideLoading();
          this.renderLoadMore();
        })
        .catch((error) => {
          console.error("Error loading collection:", error);
          this.productList.innerHTML =
            "<p>Failed to load products. Please try again later.</p>";
          this.hideLoading();
        });
    }

    updateActiveSubTab() {
      const pathMatch = window.location.pathname.match(
        /\/collections\/[^\/]+(?:\/([^\/\?]+))?/
      );
      const activeTag = pathMatch?.[1] || "all";

      const subTabs = document.querySelectorAll(".convx__sub-tab");

      subTabs.forEach((tab) => {
        if (tab.dataset.subTag === activeTag) {
          tab.classList.add("active");
        } else {
          tab.classList.remove("active");
        }
      });
    }

    attachSubTabsEvents(initialTag = "all") {
      const subTabButtons =
        this.subTabsContainer.querySelectorAll(".convx__sub-tab");

      subTabButtons.forEach((tabBtn) => {
        const tag = tabBtn.dataset.subTag;

        if (tag === initialTag) {
          tabBtn.classList.add("active");
        }

        tabBtn.addEventListener("click", () => {
          subTabButtons.forEach((btn) => btn.classList.remove("active"));
          tabBtn.classList.add("active");

          const sortBy = this.sortDropdown ? this.sortDropdown.value : "manual";

          const currentPathParts =
            window.location.pathname.split("/collections/");
          const currentCollectionHandle = currentPathParts[1]?.split("/")[0];

          const tagSlug = tag.toLowerCase().replace(/\s+/g, "-");
          const newUrl = `/collections/${currentCollectionHandle}/${tagSlug}?sort_by=${sortBy}`;

          history.pushState({}, "", newUrl);

          this.renderCollection(currentCollectionHandle, tagSlug, sortBy);
        });
      });
    }

    filterProductsByTag(tag) {
      const productCards = this.productList.querySelectorAll(
        "[data-product-tags]"
      );
      let visibleCount = 0;

      productCards.forEach((card) => {
        const tags = card.dataset.productTags.split(",").map((t) => t.trim());
        const shouldShow = tag === "all" || tags.includes(tag);
        card.style.display = shouldShow ? "" : "none";
        if (shouldShow) visibleCount++;
      });

      this.updateProductCount();
    }

    showLoading() {
      this.productList.innerHTML = `<div class="convx__loading-spinner">Loading...</div>`;
    }

    hideLoading() {
      const spinner = this.productList.querySelector(".convx__loading-spinner");
      if (spinner) spinner.remove();
      bindSpinnerClickEvents(500);
    }
  }

  class ConvxCollectionsFilter extends HTMLElement {
    constructor() {
      super();
      this.collectionBlocks = this.querySelector(".convx__collection-blocks");
      this.flickityInstance = null;
      this.progressBar = null;

      //this._boundResizeHandler = this.updateFlickity.bind(this);
    }

    /*connectedCallback() {
      this.initFlickity();

      window.addEventListener("resize", this._boundResizeHandler);

      imagesLoaded(this, () => {
        this.flickityInstance.resize();
        this.flickityInstance.reloadCells();
      });
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.updateFlickity.bind(this));
      if (this.flickityInstance) {
        this.flickityInstance.destroy();
      }
    }

    // connectedCallback() {
    //   this.initFlickity();
    //   // this.initFilterEvents();
    //   window.addEventListener("resize", this.updateFlickity.bind(this));
    // }

    // disconnectedCallback() {
    //   window.removeEventListener("resize", this.updateFlickity.bind(this));
    //   if (this.flickityInstance) {
    //     this.flickityInstance.destroy();
    //   }
    // }

    initFilterEvents() {
      const tags = this.querySelectorAll(".tag_item");
      tags.forEach((tag) => {
        tag.addEventListener("click", () => {
          // UI: update selected class
          tags.forEach((t) => t.classList.remove("is-selected"));
          tag.classList.add("is-selected");

          const selectedTag = tag.getAttribute("data-collection-tag");
          this.filterProductsByTag(selectedTag);
        });
      });

      // Auto-select default tag on load
      const defaultTag = this.querySelector(".tag_item[data-default='true']");
      if (defaultTag) {
        const selectedTag = defaultTag.getAttribute("data-collection-tag");
        this.filterProductsByTag(selectedTag);
      }
    }

    filterProductsByTag(tag) {
      const allCards = document.querySelectorAll("convx-product-card");
      allCards.forEach((card) => {
        const tags = card.getAttribute("data-product-tags");
        if (
          tags &&
          tags
            .split(",")
            .map((t) => t.trim())
            .includes(tag)
        ) {
          card.style.display = ""; // show
        } else {
          card.style.display = "none"; // hide
        }
      });
    }

    getFlickityOptions() {
      return window.innerWidth < 768
        ? {
            cellAlign: "center",
            contain: true,
            groupCells: true,
            draggable: true,
            prevNextButtons: false,
            pageDots: false,
            freeScroll: true,
            adaptiveHeight: true,
            percentPosition: true,
            imagesLoaded: true,
          }
        : {
            cellAlign: "center",
            contain: true,
            groupCells: false,
            draggable: true,
            prevNextButtons: false,
            pageDots: false,
            freeScroll: true,
            adaptiveHeight: false,
            percentPosition: true,
            imagesLoaded: true,
          };
    }

    initFlickity() {
      if (this.flickityInstance) {
        this.flickityInstance.destroy();
      }

      this.flickityInstance = new Flickity(
        this.collectionBlocks,
        this.getFlickityOptions()
      );

      this.progressBar = this.querySelector(".progress-bar");
      if (this.progressBar) {
        this.flickityInstance.on("scroll", (progress) => {
          progress = Math.max(0, Math.min(1, progress));
          this.progressBar.style.width = progress * 100 + "%";
        });
      }
    }

    updateFlickity() {
      this.initFlickity();
    }*/
  }

  function onDOMContentLoaded() {
    const path = location.pathname;
    const isHomePage = path == "/";
    const isProducts = path.includes("/products");
    const isCollections = path.includes("/collections") && !isProducts;
    const isCart = path == "/cart";

    customElements.define("convx-collections", ConvxCollections);

    customElements.define("convx-collections-filter", ConvxCollectionsFilter);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
      once: true,
    });
  } else {
    onDOMContentLoaded();
  }
})();
